import { saveAs } from 'file-saver';
import moment from 'moment';
import React, { Component } from 'react';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';


export default class ShopReportShort extends Component {

    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;

        var sid = Context.GetContext().Sid;
        var shops = Comm.CallServerFunction("shop/get_shops", { session: sid }).shops;

        //console.log(shops);
        this.state = {
            sid: sid,
            shops: shops,
            StartDate: moment(),
            EndDate: moment(),
            //perkilo: "1",

        };

        this.Export = this.Export.bind(this);
        this.PrintElem = this.PrintElem.bind(this);
        this.Search = this.Search.bind(this);
        this.LoadArticles = this.LoadArticles.bind(this);
        this.SubreportByDay = this.SubreportByDay.bind(this);
        this.SubreportTotal = this.SubreportTotal.bind(this);

        this.LoadArticles();


    }

    SubreportByDay(day) {
        console.log("day", day);
        let articles = new Set(day.map(x => x.article));
        let result = Array.from(articles).map(x => {
            let sales = day.filter(a => a.article === x);
            let qty = sales.map(x => x.qty).reduce((accumulator, currentValue) => accumulator + currentValue);
            let sum = sales.map(x => x.sum).reduce((accumulator, currentValue) => accumulator + currentValue);
            console.log("sales", sales);
            console.log("qty", qty);
            console.log("sum", sum);
            console.log(day.filter(a => a.article === x));
            let data = {
                article: x,
                qty: qty,
                sum: sum
            };
            return data;

        });

        console.log("result", result);
        return result;


    }

    SubreportTotal() {
        let allDays = [];
        for (let d of this.state.rows.data.days) {
            console.log("d", d);
            allDays = allDays.concat(d.day.data);
        }

        console.log("allDays", allDays);
        let articles = new Set(allDays.map(x => x.article));
        let result = Array.from(articles).map(x => {
            let sales = allDays.filter(a => a.article === x);
            let qty = sales.map(x => x.qty).reduce((accumulator, currentValue) => accumulator + currentValue);
            let sum = sales.map(x => x.sum).reduce((accumulator, currentValue) => accumulator + currentValue);
            let data = {
                article: x,
                qty: qty,
                sum: sum
            };
            return data;

        });

        console.log("result", result);
        return result;


    }

    LoadArticles() {
        var self = this;
        let data = {
            session: Context.GetContext().Sid,
            from: moment(self.state.StartDate).format("YYYYMMDD"),
            to: moment(self.state.EndDate).format("YYYYMMDD"),
        };
        if (this.state.shopId)
            data.shop = this.state.shopId;

        if (this.state.perkilo)
            data.per_kilo = (this.state.perkilo === "1");


        var result = Comm.CallServerFunction("shop/articles_for_reporting", data);
        console.log("result", result);
        this.setState({ articles: result.data });

    }

    Export(content) {
        var html = "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8' /></head><body>" + content + "</body></html>"
        var file = new Blob([html]);
        saveAs(file, "export.xls");

    }

    PrintElem() {
        var mywindow = window.open('', 'PRINT', 'height=400,width=600');

        mywindow.document.write('<html><head><title>' + document.title + '</title>');

        mywindow.document.write('</head><body >');
        //mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(document.getElementById("tResult").outerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        mywindow.print();
        mywindow.close();

        this.Search();
        return true;
    }

    Search(print = false) {
        var self = this;
        var data = {
            session: this.state.sid,
            from: moment(this.state.StartDate).format("YYYYMMDD"),
            to: moment(this.state.EndDate).format("YYYYMMDD"),
            page: (print ? 0 : this.state.page - 1),
            pagesize: (print ? 1000000000 : this.state.pageSize)
        };
        if (this.state.shopId)
            data.shop = this.state.shopId;

        if (this.state.perkilo)
            data.per_kilo = (this.state.perkilo === "1");
        if (this.state.articleId)
            data.article = this.state.articleId;
        var result = Comm.CallServerFunction("shop/report_short", data);
        //console.log("result", result);

        if (print) {
            this.setState({
                rows: result
            }, () => self.PrintElem());
        } else {
            this.setState({
                rows: result
            });
        }


    }




    render() {

        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }

        if (Context.RenderNotOK(this.props.history))
            return null;

        var self = this;

        console.log("rows", this.state.rows);
        return (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("shopreportshort")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-4">
                            <label for="dpStartDateAnd">{Translation.Trans("shop")}</label>
                            <select className="form-control" value={this.state.shopId} onChange={(e) => this.setState({ shopId: e.target.value }, () => this.LoadArticles())}>
                                <option></option>
                                {
                                    this.state.shops.map(x => <option value={x.id}>{x.name}</option>)
                                }
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label for="dpStartDateAnd">{Translation.Trans("FromDate")}</label>
                            <Datetime
                                inputProps={{ placeholder: 'N/A', readOnly: "true", className: "form-control pointhand" }}
                                dateFormat="DD.MM.YYYY"
                                timeFormat=""
                                onChange={(e) => self.setState({ StartDate: e }, () => this.LoadArticles())}
                                value={this.state.StartDate}
                                closeOnSelect="true"
                            ></Datetime>

                        </div>
                        <div className="col-md-4">
                            <label for="dpEndDateAnd">{Translation.Trans("ToDate")}</label>
                            <Datetime
                                inputProps={{ placeholder: 'N/A', readOnly: "true", className: "form-control pointhand" }}
                                dateFormat="DD.MM.YYYY"
                                timeFormat=""
                                onChange={(e) => self.setState({ EndDate: e }, () => this.LoadArticles())}
                                value={this.state.EndDate}
                                closeOnSelect="true"
                            ></Datetime>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label for="dpStartDateAnd">{Translation.Trans("saletype")}</label>
                            <select className="form-control" value={this.state.perkilo} onChange={(e) => this.setState({ perkilo: e.target.value }, () => this.LoadArticles())}>
                                <option></option>
                                <option value="1">{Translation.Trans("perkilo")}</option>
                                <option value="2">{Translation.Trans("perpiece")}</option>
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label for="dpStartDateAnd">{Translation.Trans("articles")}</label>
                            <select className="form-control" value={this.state.articleId} onChange={(e) => this.setState({ articleId: e.target.value })}>
                                <option></option>
                                {
                                    this.state.articles && this.state.articles.map(x => <option value={x.article}>{x.article}</option>)
                                }
                            </select>
                        </div>
                        <div className="col-md-4">
                            <button type="button" className="btn btn-default" onClick={() => this.setState({ page: 1 }, () => this.Search())}>{Translation.Trans("report")}</button>
                            <button type="button" className="btn btn-default" onClick={() => this.Search(true)}>{Translation.Trans("print")}</button>
                        </div>
                    </div>
                    {this.state.rows && this.state.rows.data.days ?
                        <div className="row">
                            <div className="col-md-12">
                                <table className="table table-bordered" id="tResult">
                                    <thead>
                                        <th>{Translation.Trans("date")}</th>
                                        <th>{Translation.Trans("shop")}</th>
                                        <th>{Translation.Trans("article")}</th>
                                        <th>{Translation.Trans("price")}</th>
                                        <th>{Translation.Trans("quantity")}</th>
                                        <th>{Translation.Trans("total")}</th>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.rows.data.days.map(dt =>
                                                [
                                                    <tr><td><b>{dt.day.total.date}</b></td></tr>,
                                                    [
                                                        dt.day.data.map(d => <tr>
                                                            <td></td>
                                                            <td>{d.shop}</td>
                                                            <td>{d.article}</td>
                                                            <td align="right">{d.price.toFixed(2)}</td>
                                                            <td align="right">{d.qty.toFixed(2)}</td>
                                                            <td align="right">{d.sum.toFixed(2)}</td>
                                                        </tr>)

                                                    ],

                                                    <tr>
                                                        <td>{dt.day.total.date}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td align="right"></td>
                                                        <td align="right">{dt.day.total.qty.toFixed(2)}</td>
                                                        <td align="right">{dt.day.total.sum.toFixed(2)}</td>
                                                    </tr>,
                                                    [
                                                        self.SubreportByDay(dt.day.data).map(d => <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td>{d.article}</td>
                                                            <td align="right"></td>
                                                            <td align="right">{d.qty.toFixed(2)}</td>
                                                            <td align="right">{d.sum.toFixed(2)}</td>
                                                        </tr>)

                                                    ],

                                                    <tr>
                                                        <td colSpan="5"><hr></hr></td>
                                                    </tr>

                                                ]

                                            )
                                        }
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td align="right"></td>
                                            <td align="right">{this.state.rows.data.total.qty}</td>
                                            <td align="right">{this.state.rows.data.total.summ}</td>
                                        </tr>,
                                        {
                                            self.SubreportTotal().map(d => <tr>
                                                <td></td>
                                                <td></td>
                                                <td>{d.article}</td>
                                                <td align="right"></td>
                                                <td align="right">{d.qty.toFixed(2)}</td>
                                                <td align="right">{d.sum.toFixed(2)}</td>
                                            </tr>)

                                        }
                                    </tbody>
                                </table>




                            </div>
                        </div>
                        : null}

                </div>


            </div>

        );
    }

}





// WEBPACK FOOTER //
// ./src/pages/shopreportshort.js